import { Record } from "immutable";
import { onModifiersLoadSuccess } from "../Modifiers/actions";
import {
    onDishLoad,
    onDishLoadSuccess,
    onDishLoadFail,
    onDishChangeAttribute,
    onDishUpdate,
    onDishUpdateSuccess,
    onDishUpdateFail,
    onDishNewLoad,
    onDishNewLoadSuccess,
    onDishNewLoadFail,
    onDishNewSave,
    onDishNewSaveSuccess,
    onDishNewSaveFail,
    onDishAddModifier,
    onDishAddRestaurant,
    onDishChangeTag,
    onDishChangeTaxes,
    onDishChangeAllergens,
    onAllergensLoad,
    onAllergensLoadSuccess,
    onAllergensLoadFail,
    onAllergenshUpdateSuccess,
    onAllergensUpdate,
    onAllergensUpdateFail,
    onModifierUpdate,
    onModifierUpdateSuccess,
    onModifierUpdateFail,
} from "./actions";

const dish = new Record({
    loading: false,
    dish: {
        limit_checked: false,
        limit: 0,
        modifier_groups: [],
        all_future_locations: false,
        is_all_restaurants: false,
        checked_restaurants:[]
     },
    checkedModifier: [],
    modifierCategories: [],
    categories: [],
    restaurants: [],
    currency: {},
    tags: [],
    allergens: [],
    tax:[],
    photo: [],
})();

export default (state = dish, action) => {
    switch (action.type) {
        case onAllergensLoad().type:
            return state
                .set("allergens", [])
                .set("loading", true);
        case onAllergensLoadSuccess().type:
            return state
                .set("allergens", action.data.data)
                .set("dishAllergens", action.data.dishAllergens)
                .set("loading", false);
        case onAllergensLoadFail().type:
            return state.set("loading", false);

        case onAllergensUpdate().type:
            return state.set("loading", true);
        case onAllergenshUpdateSuccess().type:
            return state.set("loading", false);
        case onAllergensUpdateFail().type:
            return state.set("loading", false);

        case onDishLoad().type:
            return state.set("loading", true);

        case onDishLoadSuccess().type:
            return state
                .set("loading", false)
                .set("dish", action.data.dish)
                .set("modifierCategories", action.data.modifierCategories)
                .set("categories", action.data.categories)
                .set("restaurants", action.data.restaurants)
                .set("tags", action.data.tags)
                .set("dishTags", action.data.dishTags)
                .set("tax", action.data.tax)
                .set("dishTax", action.data.dishTax)
                .set("currency", action.data.currency)
                .set("photo", action.data.photo_thumb)
                // .setIn(["dish","all_future_locations"], action.data.dish.all_future_locations)
                // .setIn(["dish","is_all_restaurants"], action.data.dish.is_all_restaurants)
                // .setIn(["dish","checked_restaurants"], action.data.dish.checked_restaurants)

        case onDishLoadFail().type:
            return state.set("loading", false);

        case onDishChangeAttribute().type:
            return state.setIn(["dish", action.attr], action.value);

        case onDishUpdate().type:
        case onModifierUpdate().type:
            return state.set("loading", true);

        case onDishUpdateSuccess().type:
        case onModifierUpdateSuccess().type:
            return state.set("loading", false);

        case onDishUpdateFail().type:
        case onModifierUpdateFail().type:
            return state.set("loading", false);

        case onDishNewLoad().type:
            return state
                .set("dish", {
                    name: "",
                    comment: "",
                    price: "",
                    tax_percent: "",
                    weight: "",
                    calories: "",
                    category_id: action.catId,
                    limit_checked: false,
                    limit: 0,
                    all_future_locations: false,
                    is_all_restaurants: false,
                    checked_restaurants:[],
                    modifier_groups: [],
                    photo_thumb: "",
                })
                .set("modifierCategories", [])
                .set("categories", [])
                .set("restaurants", [])
                .set("loading", true);

        case onDishNewLoadSuccess().type:
            return state
                .set("loading", false)
                .set("categories", action.data.categories)
                .set("restaurants", action.data.restaurants)
                .set("tags", action.data.tags)
                .set("tax", action.data.tax);

        case onDishNewLoadFail().type:
            return state.set("loading", false);

        case onDishNewSave().type:
            return state.set("loading", true);
        case onDishNewSaveSuccess().type:
            return state
            .set("loading", false)
            .set("dish", action.data.dish);
        case onDishNewSaveFail().type:
            return state.set("loading", false);

        case onModifiersLoadSuccess().type:{
            const data = action.data.items.data.map(item => ({...item, modifier_items:[] }))
            return state.set("checkedModifier", data)
        }

        case onDishAddModifier().type: {
            let items;
            let checkedItems;
            const {item, checked } = action.item
            const getCurrentParent = state.checkedModifier.find(category => category.id === item.category_id)

            if(checked){
                const newItems = getCurrentParent.modifier_items.push(item)
                items = {...getCurrentParent, modifier_items: newItems }
            } else{
                const newItems = getCurrentParent.modifier_items.filter(mod => mod.id !== item.id)
                items = {...getCurrentParent, modifier_items: newItems }
            }

            // let category;

            // let items;

            // if (checked) {
            //     category = state.getIn(["dish", "modifier_categories"]);
            //     value === "Parent" &&  category.push(item);

            // } else {
            //     category = state
            //         .getIn(["dish", "modifier_categories"])
            //         .filter((cat)=> cat.id !== item.id)
            // }

            // const currentCategory = state.dish.modifier_categories.find(item => item.id === parrenId)
            // const removeItems = currentCategory.modifier_items.filet(item => item.id !== id)
        //    const addNewItems = {...currentCategory,modifier_items: [...currentCategory.modifier_items, item]}
        //    const addNewItems = {...currentCategory,modifier_items: [...currentCategory.modifier_items, item]}

            // if(checked){
            //     items = state.getIn(["dish", "checkedModifier"]);
            //     value === "Child" &&  items.push(item)
            //         console.log(state.dish.checkedModifier,'checkedModifier');
            // } else {
            //     items = state
            //         .getIn(["dish", "checkedModifier"])
            //         .filter((mod)=> mod.id !== item.id)
            // }
            // console.log(state.dish.modifier_categories,'is modifier_categories')
            return (
                // state.setIn(["dish", "modifier_categories"], category),
                state.set("checkedModifier", items)
                )
        }

        case onDishAddRestaurant().type: {
            const checked = state.getIn([
                "restaurants",
                action.index,
                "checked",
            ]);
            return state.setIn(
                ["restaurants", action.index, "checked"],
                !checked
            );
        }

        case onDishChangeTag().type: {
            let tags = [];
            state.get("tags").forEach((item) => {
                action.tag.forEach((item2) => {
                    if (item2.value === item.slug.en) {
                        tags.push(item);
                    }
                });
            });
            return state.setIn(["dish", "tags"], tags);
        }

        case onDishChangeTaxes().type: {
            let tax = [];
            state.get("tax").forEach((item) => {
                action.tax.forEach((item2) => {
                    if (item2.value === item.slug.en) {
                        tax.push(item);
                    }
                });
            });
            return state.setIn(["dish", "tax"], tax);
        }

        case onDishChangeAllergens().type: {
            let allergens = [];
            state.get("allergens").forEach((item) => {
                action.allergens.forEach((item2) => {
                    if (item2.value === item.name) {
                        allergens.push(item);
                    }
                });
            });
            return state.setIn(["dish", "allergens"], allergens);
        }

        default:
            return state;
    }
};
